import { render } from "./InstallmentState.vue?vue&type=template&id=28bddff0"
import script from "./InstallmentState.vue?vue&type=script&lang=js"
export * from "./InstallmentState.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__